// Copyright ©️ 2026 eVolve MEP, LLC

import type { MachineElement } from '@evolvemep/api-ts';
import { Button } from '@mantine/core';

import { AgGridStyleTooltip } from 'components/Mantine/AgGridStyleTooltip';
import { isNotNil, isNil } from 'helpers/isNotNil';
import { useMachineElementActions } from 'modules/Shop/EvolveFabrication/machineElementActions/useMachineElementActions';

type ViewBendQAButtonProps = {
  element: MachineElement;
  onBendUpdated: (updatedBend: MachineElement) => void;
};

/** Used to open the Bend QA modal for a given element. */
export const ViewBendQAButton = ({ element, onBendUpdated }: ViewBendQAButtonProps) => {
  const { viewBend } = useMachineElementActions();

  if (!element.hasBendData) return null;
  return (
    <AgGridStyleTooltip
      label="No bender profile is assigned to this bend."
      openDelay={0}
      hidden={isNotNil(element.benderProfile)}
    >
      <Button
        size="compact-sm"
        variant="light"
        onClick={() => viewBend(element.elementId, onBendUpdated)}
        disabled={isNil(element.benderProfile)}
      >
        View bend
      </Button>
    </AgGridStyleTooltip>
  );
};
